import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock, faTimes } from '@fortawesome/free-solid-svg-icons';
import baseURL from '../url';
import './EstadoRestaurante.css';

export default function EstadoRestaurante() {
    const [estadoAbierto, setEstadoAbierto] = useState(true);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [horarios, setHorarios] = useState([]);
    const [diaActual, setDiaActual] = useState(0);
    const [horaActual, setHoraActual] = useState('');

    const diasSemana = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];

    useEffect(() => {
        verificarEstado();
        const interval = setInterval(verificarEstado, 60000); // Verificar cada minuto
        return () => clearInterval(interval);
    }, []);

    const verificarEstado = () => {
        fetch(`${baseURL}/horariosCheck.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    setEstadoAbierto(data.abierto);
                    setDiaActual(data.diaActual);
                    setHoraActual(data.horaActual);
                }
            })
            .catch(error => {
                console.error('Error al verificar estado:', error);
                setEstadoAbierto(true); // Por seguridad, mostrar como abierto si hay error
            });
    };

    const cargarHorarios = () => {
        fetch(`${baseURL}/horariosGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    const horariosCompletos = diasSemana.map((dia, index) => {
                        const horarioExistente = data.horarios.find(h => h.dia_semana == index);
                        return horarioExistente || {
                            dia_semana: index,
                            activo: 0
                        };
                    });
                    setHorarios(horariosCompletos);
                }
            })
            .catch(error => console.error('Error al cargar horarios:', error));
    };

    const openModal = () => {
        cargarHorarios();
        setModalIsOpen(true);
    };

    const closeModal = () => {
        setModalIsOpen(false);
    };

    const formatearHora = (hora) => {
        if (!hora) return '';
        return hora.substring(0, 5); // HH:MM
    };

    return (
        <>
            <div className='estadoRestaurante' onClick={openModal}>
                <FontAwesomeIcon icon={faClock} />
                <span className={estadoAbierto ? 'abierto' : 'cerrado'}>
                    {estadoAbierto ? 'ABIERTO' : 'CERRADO'}
                </span>
            </div>

            <Modal
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                className="modal-horarios"
                overlayClassName="overlay-horarios"
            >
                <div className='modalHorariosContainer'>
                    <div className='headerHorarios'>
                        <h3><FontAwesomeIcon icon={faClock} /> Horarios de Atención</h3>
                        <button onClick={closeModal} className='closeBtnHorarios'>
                            <FontAwesomeIcon icon={faTimes} />
                        </button>
                    </div>

                    <div className='horariosLista'>
                        {horarios.map((horario, index) => (
                            <div 
                                key={index} 
                                className={`horarioItem ${index === diaActual ? 'diaActual' : ''} ${!horario.activo ? 'cerrado' : ''}`}
                            >
                                <div className='horarioDiaLabel'>
                                    {diasSemana[index]}
                                    {index === diaActual && <span className='badge'>Hoy</span>}
                                </div>
                                <div className='horarioHoras'>
                                    {horario.activo ? (
                                        <>
                                            {horario.apertura1 && horario.cierre1 && (
                                                <span>{formatearHora(horario.apertura1)} - {formatearHora(horario.cierre1)}</span>
                                            )}
                                            {horario.apertura2 && horario.cierre2 && (
                                                <span>{formatearHora(horario.apertura2)} - {formatearHora(horario.cierre2)}</span>
                                            )}
                                        </>
                                    ) : (
                                        <span className='textoCerrado'>Cerrado</span>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </Modal>
        </>
    );
}



